import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e18c36c")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_main = _resolveComponent("el-main")
  const _component_EFooter = _resolveComponent("EFooter")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, { class: "wrapper" }, {
    default: _withId(() => [
      _createVNode(_component_el_main, { class: "content" }, {
        default: _withId(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }),
      _createVNode(_component_el_footer, null, {
        default: _withId(() => [
          _createVNode(_component_EFooter)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})